<!-- Popover -->
<div class="searcher-popover" (click)="$event.stopPropagation()">
  <!-- Search Input -->
  <div class="searcher-input">
    <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100 searcher-form-field">
      <mat-icon matPrefix>search</mat-icon>
      <input
        #searchInput
        matInput
        [placeholder]="'Searcher.Placeholder' | translate"
        (input)="onSearchChange($any($event.target).value)"
      />
    </mat-form-field>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Results -->
  @if (searchQuery().length >= 3 || isLoading()) {
    <div class="searcher-results">
      @if (isLoading()) {
        <div class="flex justify-center py-4">
          <mat-spinner diameter="24" />
        </div>
      } @else if (results().length > 0) {
        @for (item of results(); track item.id) {
          <div class="result-row" (click)="selectItem(item)">
            <mat-icon class="result-type-icon">{{ getIconForType(item.type) }}</mat-icon>
            <div class="flex flex-col flex-1 overflow-hidden">
              <span class="result-name">{{ item.name?.[currentLang()] || item.name || 'Untitled' }}</span>
              <span class="result-meta">
                {{ 'Search.Types.' + item.type | translate }}
                @if (item.courseName) {
                  &bull; {{ item.courseName }}
                }
              </span>
            </div>
            @if (mode() === 'navigate') {
              <mat-icon class="result-add-icon">chevron_right</mat-icon>
            } @else {
              <mat-icon class="result-add-icon">add_circle_outline</mat-icon>
            }
          </div>
        }
      } @else {
        <div class="empty-state">
          <mat-icon>search_off</mat-icon>
          <span>{{ 'Searcher.NoResults' | translate }}</span>
        </div>
      }
    </div>
  }
</div>
